import { createEffectFn } from '@ngneat/effects';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap } from 'rxjs';
import { auditProposalSuppliersServices } from './audit-proposal-suppliers/audit-proposal-suppliers.services';

interface AuditProposalSupEmailEffectParams {
  email: string;
  auditsProposalDetailsId: number;
}

export const AuditProposalSupEmailEffectfn = createEffectFn((params$: Observable<AuditProposalSupEmailEffectParams>) => {
  return params$.pipe(
    debounceTime(500),
    distinctUntilChanged(),
    switchMap(({ auditsProposalDetailsId, email}) => auditProposalSuppliersServices.patchAuditsSupEmail(auditsProposalDetailsId, email).pipe(
        switchMap(() => auditProposalSuppliersServices.getAuditsProposalSupplierDetails(auditsProposalDetailsId)),
        catchError(() => EMPTY),
      )
    )
  );
});